import { c as _c } from "react/compiler-runtime";
import { PaymentProcessorEnum, Tooltip, copyTextToClipboard, getPaymentProcessorTitle, toast } from '@systemeio/ui';
import { Integration } from 'modules/profile/payment-gateways/components/integration';
import { useConnectedPaymentIntegrations } from 'modules/profile/payment-gateways/hooks/use-connected-payment-integrations';
import { mercadoPagoDisconnect } from 'modules/profile/payment-gateways/integrations/mercadopago/api';
import MercadoPagoCreateModal from 'modules/profile/payment-gateways/integrations/mercadopago/components/mercado-pago-create-modal';
import { mercadoPagoPaymentProcessors } from 'modules/profile/payment-gateways/integrations/mercadopago/constants';
import { MercadoPagoPaymentIntegrationInterface } from 'modules/profile/payment-gateways/integrations/mercadopago/types';
import { getMercadoPagoHelpPageLink } from 'modules/profile/payment-gateways/integrations/mercadopago/utils';
import React, { FC, useState } from 'react';
import ConfirmationModal from 'shared/components/confirmation-modal';
import TransLoco from 'shared/components/trans-loco';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { BinIcon, CopyIcon, MercadoLogoIcon } from '@systemeio/ui/icons';
export const Mercadopago: FC = () => {
  const $ = _c(9);
  const {
    user
  } = useUser();
  const {
    t
  } = useLocoTranslation();
  const {
    getConnectedPaymentIntegration,
    removePaymentIntegration
  } = useConnectedPaymentIntegrations();
  const [deleteOpened, setDeleteOpened] = useState(false);
  let t0;
  if ($[0] !== deleteOpened || $[1] !== getConnectedPaymentIntegration || $[2] !== removePaymentIntegration || $[3] !== t || $[4] !== user?.dashboardLocale) {
    const mercadopagoIntegration = getConnectedPaymentIntegration({
      matcher: _temp
    });
    const title = getPaymentProcessorTitle(mercadopagoIntegration ? mercadopagoIntegration.paymentProcessor : PaymentProcessorEnum.MercadoPagoAR);
    const onDelete = async () => {
      await mercadoPagoDisconnect();
      await removePaymentIntegration({
        matcher: _temp2
      });
      toast.success(t("dashboard.settings.payment-gateways.account_removed", {
        payment: title
      }));
    };
    let t1;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <MercadoLogoIcon />;
      $[6] = t1;
    } else {
      t1 = $[6];
    }
    const t2 = user?.dashboardLocale;
    let t3;
    if ($[7] !== t2) {
      t3 = getMercadoPagoHelpPageLink(t2);
      $[7] = t2;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t0 = <Integration logo={t1} additionalInfo={<a className="primary-link" href={t3} target="_blank" rel="noreferrer"><TransLoco t={t} i18nKey="dashboard.settings.payment_gateways.help_article_label" values={{
        integration: title
      }} /></a>}>{mercadopagoIntegration ? <div className="flex w-full justify-between gap-3 overflow-hidden"><div className="flex flex-col gap-1 truncate">{!mercadopagoIntegration.readyToUse && <p className="flex gap-1">{t("dashboard.settings.payment-gateways.integration_in_progress")}</p>}{mercadopagoIntegration.details.publicKey && <p className="flex items-center gap-1 text-base lg:text-lg"><span>{`${t("dashboard.settings.payment-gateways.api_public_key")}:`}</span><span className="text-text-primary truncate">{mercadopagoIntegration.details.publicKey}</span></p>}{mercadopagoIntegration.details.accountId && <p className="flex items-center gap-1 text-base lg:text-lg"><span>{`${t("dashboard.settings.payment-gateways.user_id")}:`}</span><span className="text-text-primary truncate">{mercadopagoIntegration.details.accountId}</span></p>}{mercadopagoIntegration.details.webhookUrl && <div className="flex items-center gap-1 text-base lg:text-lg"><span>{`${t("dashboard.settings.payment-gateways.webhook_url")}:`}</span><span className="text-text-primary truncate">{mercadopagoIntegration.details.webhookUrl}</span><Tooltip mode="hover" label={t("global.copy")}><button onClick={async () => {
                await copyTextToClipboard(mercadopagoIntegration.details.webhookUrl || "", t("global.copy_clipboard"));
              }} className="group outline-hidden"><CopyIcon className="main-transition-colors group-focus-visible:fill-brand-primary hover:fill-brand-primary h-[16px] w-[16px] cursor-pointer sm:h-[20px] sm:w-[20px]" /></button></Tooltip></div>}<div className="w-full truncate"><a className="primary-link" href={`${getMercadoPagoHelpPageLink(user?.dashboardLocale)}#webhookmercadopago`} target="_blank" rel="noreferrer">{t("dashboard.settings.payment-gateways.configure_webhook")}</a></div></div><Tooltip mode="hover" label={t("dashboard.settings.payment-gateways.remove_integration", {
          payment: title
        })} wrapperClassName="flex items-center" className="h-fit"><button className="group outline-hidden" onClick={() => setDeleteOpened(true)}><BinIcon className="group-focus-visible:fill-danger hover:fill-danger main-transition-colors h-[16px] w-[16px]" /></button></Tooltip><ConfirmationModal title={t("dashboard.settings.payment-gateways.remove_integration_description", {
          payment: title
        })} confirmationText={t("dashboard.settings.payment-gateways.remove_payment_text.mercado")} opened={deleteOpened} onClose={() => setDeleteOpened(false)} onConfirm={onDelete} /></div> : <MercadoPagoCreateModal />}</Integration>;
    $[0] = deleteOpened;
    $[1] = getConnectedPaymentIntegration;
    $[2] = removePaymentIntegration;
    $[3] = t;
    $[4] = user?.dashboardLocale;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  return t0;
};
function _temp(paymentProcessor) {
  return mercadoPagoPaymentProcessors.includes(paymentProcessor);
}
function _temp2(paymentProcessor_0) {
  return mercadoPagoPaymentProcessors.includes(paymentProcessor_0);
}